import React from "react";
import SectionHeader, { SectionWrapper, Reveal } from "./SectionHeader";

const TAGS = [
  { label: "Merit", color: "yellow" },
  { label: "Tech", color: "cyan" },
  { label: "Infra", color: "cyan" },
  { label: "Culture", color: "magenta" },
  { label: "Sports", color: "yellow" },
  { label: "AI", color: "cyan" },
  { label: "Space", color: "cyan" },
  { label: "Memes", color: "magenta" },
  { label: "Policy", color: "yellow" },
  { label: "Startups", color: "yellow" },
  { label: "Geopolitics", color: "yellow" },
  { label: "Internet Culture", color: "magenta" },
];

const COLOR_MAP = {
  cyan: { border: "rgba(0,240,255,0.4)", text: "#00F0FF", glow: "rgba(0,240,255,0.55)" },
  magenta: { border: "rgba(255,0,255,0.4)", text: "#FF66FF", glow: "rgba(255,0,255,0.55)" },
  yellow: { border: "rgba(255,222,0,0.45)", text: "#FFDE00", glow: "rgba(255,222,0,0.55)" },
};

const WhoWeAre = () => {
  return (
    <SectionWrapper id="who">
      <SectionHeader
        code="// CH.02 — IDENTITY"
        title="Identity.Stack"
        kicker="An independent, youth-first digital media platform built on trust, culture, technology, and Bharat-first storytelling."
        tid="who"
      />

      <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
        {/* Left: big manifesto */}
        <Reveal className="md:col-span-7">
          <div className="glass-card hud-corners p-8 md:p-12 h-full">
            <span className="hud-tr" />
            <span className="hud-bl" />
            <div className="micro-label text-fuchsia-400 mb-4">MANIFEST · 01</div>
            <h3 className="font-display font-black text-3xl md:text-4xl lg:text-5xl uppercase tracking-tight leading-[1.05] mb-6 break-words">
              We don&apos;t <span className="text-cyan-400 glow-cyan interactive-text interactive-text--cyan">follow</span>
              <br />
              the narrative.
              <br />
              We expose
              <br />
              the <span className="text-fuchsia-400 glow-magenta interactive-text interactive-text--magenta">truth</span>.
            </h3>
            <div className="space-y-4 max-w-xl text-white/65 leading-relaxed text-sm md:text-base">
              <p>
                U&apos;th Times is an independent, youth-first media platform built on a simple principle —
                <span className="text-white/90"> truth over narrative</span>.
              </p>
              <p>
                In a landscape dominated by paid propaganda and agenda-driven content, our approach remains
                raw, unbiased, research-backed, and authentic.
              </p>
              <p>
                We don&apos;t manufacture opinions. <span className="text-white/90">We decode reality.</span>
              </p>
              <p>
                Every story we put out reflects ground truth — not influence.
              </p>
            </div>

            <div className="mt-8 flex items-center gap-4">
              <span className="h-[1px] flex-1 bg-gradient-to-r from-cyan-400/60 to-transparent" />
              <span className="micro-label text-white/40">EST · 2014 · BHARAT</span>
            </div>
          </div>
        </Reveal>

        {/* Right: mission + tags */}
        <div className="md:col-span-5 flex flex-col gap-6">
          <Reveal delay={0.1}>
            <div className="glass-card hud-corners p-8">
              <span className="hud-tr" />
              <span className="hud-bl" />
              <div className="micro-label text-yellow-300 mb-3">MISSION · 02</div>
              <p className="font-display text-2xl md:text-3xl font-bold uppercase leading-tight tracking-tight">
                Cut through noise.
                <br />
                Deliver{" "}
                <span
                  className="text-yellow-300 glow-yellow inline-block interactive-text interactive-text--yellow"
                  style={{ animation: "uthPulse 2.6s ease-in-out infinite" }}
                >
                  truth
                </span>
                <br />
                to India&apos;s youth.
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.2}>
            <div className="glass-card hud-corners p-8">
              <span className="hud-tr" />
              <span className="hud-bl" />
              <div className="micro-label text-cyan-400 mb-4">FOCUS · 03</div>
              <div className="flex flex-wrap gap-2">
                {TAGS.map((t) => {
                  const c = COLOR_MAP[t.color];
                  return (
                    <span
                      key={t.label}
                      className={`uth-chip who-chip interactive-text interactive-text--${t.color}`}
                      style={{
                        borderColor: c.border,
                        color: c.text,
                        "--chip-glow": c.glow,
                      }}
                      data-testid={`who-tag-${t.label.toLowerCase().replace(/\s+/g, "-")}`}
                    >
                      {t.label}
                    </span>
                  );
                })}
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </SectionWrapper>
  );
};

export default WhoWeAre;
